import Axios from "../../node_modules/axios";
import Config from "./Config";
import {framework} from 'saffroncodejs';

var UserManager = {} ;
UserManager.LOGGED_IN = "LOGGED_IN";
UserManager.PROFILE_UPDATED = "PROFILE_UPDATED";
UserManager.LOGGIN_ERROR = "LOGGIN_ERROR";
UserManager.REGISTER_ERROR = "REGISTER_ERROR";
UserManager.REGISTER_DONE = "REGISTER_DONE";
UserManager.NO_NET = "NO_NET";
UserManager.LOGGED_OUT = "LOGGED_OUT";

var UserId = "" ;//It should load userId from cash later
//TODO

var UserProfile = {"UserId":"","UserTypeBaseId":"23","UserTypeBaseTitle":null,"UserTypeLanguageBaseId":0,"FirstName":"مریم","LastName":"مالکی","EMailAddress":"maryam_22_11_66@yahoo.com","MobileNo":"09127012470","UserName":"maryam","Password":null,"IsActive":"True","Version":null,"ConfirmNumber":null,"IsConfirmed":"True","IsBlocked":false,"BlockedNote":null,"PhotoName":"","AcceptedPhotos":"","WonPhotos":"","BirthDate":"","GenderTypeBaseId":"32","GenderTypeLanguageBaseId":0,"GenderTypeBaseTitle":"","AllLikeCount":"0","CityId":"1","Adress":"تهران","TotalPhotos":"0","TotalRefereeScore":"0","AuthorizedSurveyIds":null,"Description":"کاربر تستی","PostalCode":"0078436893                                        ","IsPictureConfirmed":null} ;

UserManager.dispatcher = new framework.EventDispatcher();

/**@return {Boolean} */
UserManager.isLogin = function()
{
    //It should return true only if the user was logged in
    return UserId!=="" ;
}

/**@description Pass userName and password and wait for the LOGGED_IN or LOGGIN_ERROR events. */
UserManager.login = function(UserName='',Password='')
{
    if(UserName.length===0 || Password.length===0)
    {
        UserManager.dispatcher.dispatchEvent(UserManager.LOGGIN_ERROR);
        return ;
    }
    Axios.get(Config.domain_pic+"/login?UserName="+UserName+"&Password="+Password)
        .then((result)=>{
            if(isNaN(Number(result.data)))
            {
                UserId = result.data ;
                UserManager.dispatcher.dispatchEvent(UserManager.LOGGED_IN);
                UserManager.getUserProfile();
            }
            else
            {
                UserManager.dispatcher.dispatchEvent(UserManager.LOGGIN_ERROR);
            }
        })
        .catch(()=>{
            UserManager.dispatcher.dispatchEvent(UserManager.NO_NET);
        })
}


/**@desc It will dispatch the current user status event (logged_in or logged_out) */
UserManager.dispatchStatusEvent = function()
{
    if(UserManager.isLogin())
        UserManager.dispatcher.dispatchEvent(UserManager.LOGGED_IN);
        else
        UserManager.dispatcher.dispatchEvent(UserManager.LOGGED_OUT);
}

UserManager.logOut = function()
{
    //TODO create real logout function
    UserId = "";
    UserManager.dispatcher.dispatchEvent(UserManager.LOGGED_OUT);
}

UserManager.getUserToken = function()
{
    return UserId ;
}

UserManager.MelliCode = function()
{
    if(true && window.location.href.indexOf('localhost:')!==-1)
    {
        return '3874726101';
    }
    return UserProfile.PostalCode.split(" ").join("").split("\t").join("")  ;
}








///////////////////////////Profile

var profileGetterTimeOutId = 0 ;

/**@description Pass userName and password and wait for the LOGGED_IN or LOGGIN_ERROR events. */
UserManager.getUserProfile = function()
{
    clearTimeout(profileGetterTimeOutId);
    if(!UserManager.isLogin())
    {
        console.log("Cannot get user's profile");
        return ;
    }
    Axios.get(Config.domain_pic+"/GetUsersProfile?"+
    "LanguageBaseId="+11+
    "&OtherUserId="+UserId+
    "&UserId="+UserId)
        .then((result)=>{
            UserProfile = result.data[0] ;
            console.log("UserProfile : \n\n",JSON.stringify(UserProfile));
            UserManager.dispatcher.dispatchEvent(UserManager.PROFILE_UPDATED);
        })
        .catch(()=>{
            console.log('Connection problem to get profile');
            profileGetterTimeOutId = setTimeout(UserManager.getUserProfile,5000);
        })
}

















/**@description Pass userName and password and wait for the LOGGED_IN or LOGGIN_ERROR events. */
UserManager.regster = function(FirstName='',LastName='',EMailAddress='',
CityId=0,Adress='',MobileNo='',UserName='',Password='',BirthDate='',
isMale=true,Description='',PostalCode='')
{
    Axios.post(Config.domain_pic+"/RegisterUser",
                    {
                        "FirstName":FirstName,
                        "LastName":LastName,
                        "EMailAddress":EMailAddress,
                        "CityId":CityId,
                        "Adress":Adress,
                        "MobileNo":MobileNo,
                        "UserName":UserName,
                        "Password":Password,
                        "BirthDate":BirthDate,
                        "GenderTypeBaseId":isMale?31:32,
                        "Description":Description,
                        "PostalCode":PostalCode
                    }
                )
        .then((result)=>{
            if(!isNaN(Number(result.data)) && Number(result.data)<0)
            {
                UserManager.dispatcher.dispatchEvent(UserManager.REGISTER_ERROR,"کاربر گرامی، حساب کاربری شما قبلا ایجاد شده است.");
            }
            else
            {
                UserId = result.data ;
                UserManager.dispatcher.dispatchEvent(UserManager.REGISTER_DONE);
                UserManager.dispatcher.dispatchEvent(UserManager.LOGGED_IN);
                UserManager.getUserProfile();
            }
        })
        .catch(()=>{
            UserManager.dispatcher.dispatchEvent(UserManager.NO_NET);
        })
}






















export default UserManager ;


// WEBPACK FOOTER //
// ./src/Core/UserManager.js